export const configFormName = 'ldapSettingsConfig';
export const roleAssignmentFormName = 'ldapSettingsRoleAssignment';
